import { RefundBilling } from '@/mobile/types/api/mypage/refundBilling';
import { atom } from 'recoil';

// 返還明細は一覧描画を前提にしているため、空配列ではなく 1 行分の雛形を持って表示崩れを防ぐ。
export const refundBillingState = atom<RefundBilling>({
  key: 'refundBillingState',
  default: {
    can_display: false,
    refund_refer: [
      {
        target_ym: '',
        prc_tax_include: 0,
      },
    ],
  },
});

export default refundBillingState;
